import { makeApiUrl } from 'main/factories/http';
import { makeAuthorizeHttpClientDecorator } from 'main/factories/decorators';

import { GetBudgets } from 'domain/usecases/budgets';
import { RemoteGetBudgets } from 'data/usecases/budgets/remote-get-budgets';

export const makeGetBudgets = (): GetBudgets => {
  return new RemoteGetBudgets(makeApiUrl('/budgets'), makeAuthorizeHttpClientDecorator());
};
